// En desarrollo usa '/api' (proxy de Vite), en producción usa la URL completa del backend
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

console.log('🔧 API_BASE_URL:', API_BASE_URL);
console.log('🔧 VITE_API_BASE_URL:', import.meta.env.VITE_API_BASE_URL);
console.log('🔧 MODE:', import.meta.env.MODE);